import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Event } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: Event }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerEvents,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
